import 'core-js/stable'
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import AppRouter from "./views/routes/AppRouter";
import { store, persistor } from "./state/store";
import { PersistGate } from "redux-persist/integration/react";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import 'bootstrap/dist/js/bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import "../src/assets/css/main.css";
import "../src/assets/css/general.css";
import "../src/assets/css/login-page.css";
import "../src/assets/css/popupmodal.css";
import "../src/assets/eminevimIconLibrary/style.css";
import "../node_modules/inputmask/dist/inputmask.min.js";
import "../node_modules/inputmask/dist/jquery.inputmask.min.js";
import "react-toastify/dist/ReactToastify.css";
import "../src/assets/css/app-toast.css";

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <AppRouter />
    </PersistGate>
  </Provider>,
  document.getElementById("app")
);